<div mat-dialog-title>
  <h1 id="restore-deleted-confirm-dialog">{{ getDialogTitle() | translate }}</h1>
</div>
<div mat-dialog-content>
  <div>{{ getRestoreContentTitle() | translate }}</div>
  <div class="restored_confirm">
    @for (user of data.users; track user) {
      <div class="restored_confirm__users">{{ user.familyName }}, {{ user.givenName }}</div>
    }
  </div>

  <div>{{ 'Are you sure you want to restore them? ' | translate }}</div>
</div>
<div mat-dialog-actions>
  <cl-btn
    [mat-dialog-close]="false"
    buttonStyle="secondary">
    {{ 'Cancel' | translate }}
  </cl-btn>
  <cl-btn [mat-dialog-close]="true">{{ 'Yes' | translate }}</cl-btn>
</div>
